import { render, staticRenderFns } from "./view-nbn-trouble-ticket.vue?vue&type=template&id=d8908c34&scoped=true"
import script from "./view-nbn-trouble-ticket.vue?vue&type=script&lang=js"
export * from "./view-nbn-trouble-ticket.vue?vue&type=script&lang=js"
import style0 from "./view-nbn-trouble-ticket.vue?vue&type=style&index=0&id=d8908c34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8908c34",
  null
  
)

export default component.exports